import React from 'react';
import PropTypes from 'prop-types';
import colors from 'theme/_colors.scss';

const IconPowertrainConnection = ({ width = 16, height = 16, viewBox = '0 0 16 16', color = colors.nero }) => {
    return <svg width={width} height={height} viewBox={viewBox} fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M12.1557 10.0012C13.0998 10.0317 14.0174 9.6859 14.7066 9.03984C15.3958 8.39377 15.8002 7.50039 15.8307 6.55622C15.8612 5.61205 15.5153 4.69443 14.8693 4.00524C14.2232 3.31604 13.3298 2.91172 12.3857 2.88122C11.965 1.96365 11.2733 1.19698 10.4037 0.684379C9.53418 0.171781 8.52846 -0.0621332 7.52194 0.0141184C6.51542 0.09037 5.55641 0.473128 4.77399 1.11088C3.99158 1.74862 3.4233 2.61075 3.14566 3.58122C2.29431 3.59846 1.48469 3.95319 0.894884 4.56737C0.305082 5.18155 -0.0165802 6.00487 0.00065885 6.85622C0.0178979 7.70756 0.372626 8.51719 0.986808 9.10699C1.60099 9.6968 2.42431 10.0185 3.27566 10.0012H7.39566V12.0012H5.89566V13.0012H1.89566V14.0012H5.89566V15.0012H9.89566V14.0012H13.8957V13.0012H9.89566V12.0012H8.39566V10.0012H12.1557ZM8.89566 13.0012V14.0012H6.89566V13.0012H8.89566Z' fill={color} />
    </svg>;
};

IconPowertrainConnection.propTypes = {
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.string
};

export default IconPowertrainConnection;
